import { useEffect, useRef, useState } from "react";
import { decryptData, fmt } from "../components/const";
import SearchField from "../components/SeachField";
import UseFetch from '../components/UseFetch';
import PayerDette from "./ModalPayerDette";
import { NavLink } from "react-router-dom";
import $ from "jquery"
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const exportDettesPDF = (dettes, magasin, totaux) => {
    const doc = new jsPDF();
    const date = new Date().toLocaleDateString('fr-FR');

    doc.setFontSize(14);
    doc.text(`Magasin : ${magasin ?? ''}`, 14, 15);
    doc.setFontSize(11);
    doc.text(`Clients en dette initiale — ${date}`, 14, 23);

    doc.setFontSize(10);
    doc.setTextColor(80, 80, 80);
    doc.text(`Total dette : ${fmt(totaux.dette)} GNF`, 14, 31);
    doc.text(`Total payé : ${fmt(totaux.paye)} GNF`, 80, 31);
    doc.setTextColor(180, 0, 0);
    doc.text(`Total restant : ${fmt(totaux.reste)} GNF`, 146, 31);
    doc.setTextColor(0, 0, 0);

    const rows = dettes.map((c, i) => [
        i + 1,
        c.client,
        c.telephone,
        (c.agent ?? '').toUpperCase(),
        `${fmt(c.dette)} GNF`,
        `${fmt(c.paye)} GNF`,
        `${fmt(c.reste)} GNF`,
    ]);

    autoTable(doc, {
        startY: 36,
        head: [['N°', 'Client', 'Téléphone', 'Agent', 'Dette', 'Payé', 'Reste']],
        body: rows,
        styles: { fontSize: 9 },
        headStyles: { fillColor: [13, 110, 253] },
    });

    doc.save(`dettes_initiales_${magasin ?? 'export'}.pdf`);
};
const DetteInitiale = () => {
    const profile = decryptData('user_profile');
    const { data: dettes, isloading } = UseFetch(`dettes/${profile.idmagasin}`);
    const [totalDette, setTotalDette] = useState(0);
    const [totalPaye, setTotalPaye] = useState(0);
    const [totalReste, setTotalReste] = useState(0);
    const [selectedclient, setSelectedClient] = useState(null);
    const tableRef = useRef(null)
    useEffect(() => {
        setTotalDette(dettes?.reduce((previous, current) => { return previous + current.dette }, 0))
        setTotalPaye(dettes?.reduce((previous, current) => { return previous + current.paye }, 0))
        setTotalReste(dettes?.reduce((previous, current) => { return previous + current.reste }, 0))

    }, [dettes?.length]);
    $(tableRef.current).DataTable();

    console.log(dettes)

    return (
        isloading ? <div className="loader"></div> : dettes?.length ? <div className="dette">



            <div className="row p-2 justify-content-between align-items-center">
                <div className="row row-cols-1 row-cols-md-3 m-2">
                    <div className="col">
                        <div className="card border-0 shadow p-2">
                            <span className="text-muted">Total Dette</span>
                            <h6>{totalDette?.toLocaleString()} GNF</h6>
                        </div>
                    </div>
                    <div className="col">
                        <div className="card border-0 shadow p-2">
                            <span className="text-muted">Total Payé</span>
                            <h6>{totalPaye?.toLocaleString()} GNF</h6>
                        </div>
                    </div>
                    <div className="col">
                        <div className="card border-0 shadow p-2">
                            <span className="text-muted">Total impayé</span>
                            <h6>{totalReste?.toLocaleString()} GNF</h6>
                        </div>
                    </div>
                </div>
                <div className="d-flex justify-content-between align-items-center mb-2">
                    <div className="col-lg-4 text-primary h3">Clients en dette</div>
                    <button className="btn btn-danger" onClick={() => exportDettesPDF(dettes, profile.magasin, { dette: totalDette, paye: totalPaye, reste: totalReste })}>
                        Exporter PDF
                    </button>
                </div>
                <div className="table-responsive">

                    <table ref={tableRef} className="table table-hover table-striped table-bordered">
                        <thead className="table-primary">
                            <tr>
                                <th>N°</th>
                                <th>CLIENT</th>
                                <th>TELEPHONE</th>
                                <th>AGENT</th>
                                <th>DETTE</th>
                                <th>PAYE</th>
                                <th>RESTE</th>
                                <th className="text-end">ACTIONS</th>
                            </tr>
                        </thead>
                        <tbody className="plage">
                            {
                                dettes?.map((client, ind) => (
                                    <tr className="tr align-middle" key={ind}>
                                        <td>{ind + 1}</td>
                                        <td className="critere">{client.client}</td>
                                        <td>{client?.telephone}</td>
                                        <td>{client.agent}</td>
                                        <td>{client?.dette.toLocaleString()}</td>
                                        <td>{client?.paye.toLocaleString()}</td>
                                        <td>{client?.reste.toLocaleString()}</td>
                                        <td className="text-end">
                                            <button className="btn btn-success m-1" data-bs-toggle="modal" data-bs-target="#modalverser" onClick={() => setSelectedClient(client)}>
                                                <i className="bx bx-dollar-circle" ></i>
                                                Remb...
                                            </button>

                                            <NavLink to='/client/compte' state={{ client }} className="btn btn-primary m-1" >
                                                <i className="bx bx-show"></i> </NavLink>
                                        </td>
                                    </tr>
                                ))
                            }

                        </tbody>
                    </table>
                </div>
            </div>
            <PayerDette dette={selectedclient} />
        </div> : <div className="w-100 fs- p-2 text-center text-danger bg-danger-subtle"> Aucun client n'a une dette initiale</div>
    );
}

export default DetteInitiale;